const compose = (...args) => val => args.reverse().reduce((acc, fn) => fn(acc), val);

export { compose };
